import { render, staticRenderFns } from "./hotarea.vue?vue&type=template&id=70e86688&scoped=true"
import script from "./hotarea.vue?vue&type=script&lang=js"
export * from "./hotarea.vue?vue&type=script&lang=js"
import style0 from "./hotarea.vue?vue&type=style&index=0&id=70e86688&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e86688",
  null
  
)

export default component.exports